import script from "./AIButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIButton.vue?vue&type=script&setup=true&lang=ts"

import "./AIButton.vue?vue&type=style&index=0&id=3fe4c425&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe4c425"]])

export default __exports__